import type { ReactElement, ReactNode } from 'react';

/**
 * 제목 하나와 할 일 하나를 가운데에 세우는 안내 틀.
 *
 * 메일 링크가 닿는 화면들(`/verify`·`/reject`)이 공유한다 — 그 화면들은 갈래마다
 * 보여줄 것이 다르지만 자리는 같아야 한다. 갈래가 바뀔 때 제목이 튀면 사용자는
 * 다른 페이지로 넘어간 줄 안다.
 */
export function Notice({ title, children }: { title: string; children: ReactNode }): ReactElement {
  return (
    <div className="u-container flex justify-center py-16">
      <div className="flex w-full max-w-[26rem] flex-col gap-5 text-center">
        <h1 className="text-[1.625rem] font-bold tracking-[-0.04em]">{title}</h1>
        {children}
      </div>
    </div>
  );
}
